import { FunctionComponent, useEffect } from 'react';
import { useDispatch, useSelector } from '@cbridge-utils/react-redux';
import { SupersetAction } from '../../superset.action';
import { chartListSubscriberPropsSelector } from './ChartListSubscriber.selector';

export const ChartListSubscriber: FunctionComponent = () => {
  const dispatch = useDispatch();

  const { shouldBeLoaded } = useSelector(chartListSubscriberPropsSelector);

  useEffect(() => {
    if (shouldBeLoaded) {
      dispatch(SupersetAction.loadChartList.started());
    }
  }, [dispatch, shouldBeLoaded]);

  return null;
};
